module.exports = __webpack_public_path__ + "static/media/levels_1_5.df29dbb8.svg";